import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || '/api';

const api = axios.create({
  baseURL: API_BASE_URL,
});

export const fetchServices = () => api.get('/projects');
export const fetchServiceById = (id: number) => api.get(`/projects/${id}`);
export const fetchCategories = () => api.get('/categories');
export const fetchProjects = (categoryId?: number) => {
  if (categoryId) {
    return api.get(`/projects/category/${categoryId}`);
  }
  return api.get('/projects');
};
export const submitLead = (leadData: { name: string; email: string; message: string }) => 
  api.post('/leads', leadData);

export default api;

// Separate instance for public endpoints that don't need authentication
const publicApi = axios.create({
  baseURL: API_BASE_URL,
});

export const getCalendlyLink = () => publicApi.get('/calendly-link-public');